import React from 'react';
import { Card, List, Button, Typography, Row, Col } from 'antd';
import { 
  DownloadOutlined, 
  FileOutlined, 
  FileImageOutlined, 
  FileZipOutlined, 
  FileTextOutlined, 
  FilePdfOutlined, 
  FilePptOutlined 
} from '@ant-design/icons';

const { Title } = Typography;

// Map of file extensions to icons
const getFileIcon = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  switch (extension) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return <FileImageOutlined style={{ color: '#52c41a' }} />;
    case 'zip':
    case 'rar':
      return <FileZipOutlined style={{ color: '#fa8c16' }} />;
    case 'pdf':
      return <FilePdfOutlined style={{ color: '#f5222d' }} />;
    case 'doc':
    case 'docx':
      return <FileTextOutlined style={{ color: '#1890ff' }} />;
    case 'ppt':
    case 'pptx':
      return <FilePptOutlined style={{ color: '#fa541c' }} />;
    case 'xls':
    case 'xlsx':
      return <FileTextOutlined style={{ color: '#1890ff' }} />;
    default:
      return <FileOutlined style={{ color: '#8c8c8c' }} />;
  }
};

const ArticleAttachments = ({ attachments }) => {
  return (
    <Card style={{ width: '100%', borderRadius: '10px',marginBottom:'20px' }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
        <Col>
          <Title level={5} style={{ margin: 0 }}>
            Attachments
          </Title>
        </Col>
        <Col>
          <span>({attachments.length} total)</span>
        </Col>
      </Row>
      <List
        dataSource={attachments}
        renderItem={(attachment) => (
          <List.Item style={{ display: 'flex', alignItems: 'center', padding: '8px 0' }}>
            <Row justify="space-between" align="middle" style={{ width: '100%' }}>
              <Col>
                {getFileIcon(attachment.label)}
                <span style={{ marginLeft: '8px' }}>{attachment.label}</span>
              </Col>
              <Col>
                <Button
                  type="primary"
                  shape="circle"
                  icon={<DownloadOutlined />}
                  href={attachment.url}
                  target="_blank"
                />
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ArticleAttachments;
